import apiPrd from '../../services/apiPrd'

const NewFleetServices = {
  async postNewVehicle(payload, groupId) {
    let res
    if (groupId) {
      res = await apiPrd.put(`/fleet/${groupId}`, payload)
    } else {
      res = await apiPrd.post('/fleet', payload)
    }
    return res.data
  },

  async registerPartnerVehicle(payload, groupId) {
    let res
    if (groupId) {
      res = await apiPrd.put(`/vehicle/${groupId}`, payload)
    } else {
      res = await apiPrd.post('/vehicle', payload)
    }
    return res.data
  },
  async getIndividualVehicleData(plate) {
    const res = await apiPrd.get(`/vehicle/item/search?plate=${plate}`)
    return res.data
  },
  async updateVehicle(id, payload) {
    const res = await apiPrd.put(`/vehicle/item/${id}`, payload)
    return res.data
  },
  async updateVehicleByCiotDate(vehicleGroupId, payload) {
    const res = await apiPrd.post(
      `/vehicle/updateVehicleByCiotDate?vehicleGroupId=${vehicleGroupId}`,
      payload,
    )
    return res
  },
}

export default NewFleetServices
